import { createSlice } from "@reduxjs/toolkit";

import { initialAuthenticationState, initialSignUp, initialUser } from "./data";

const authenticationSlice = createSlice({
  name: "authentication",
  initialState: initialAuthenticationState,
  reducers: {
    setUserDetails: (state, { payload }) => {
      state.userDetails = { ...payload };
    },
    setSignUpDetails: (state, { payload }) => {
      state.signUpDetails = { ...state.signUpDetails, ...payload };
    },
    setAccessToken: (state, { payload }) => {
      state.token = payload;
    },
    setResetAuthentication: (state) => {
      state.userDetails = initialUser;
      state.signUpDetails = initialSignUp;
      state.token = "";
    },
  },
});

const { actions: authenticationActions, reducer: authenticationReducers } =
  authenticationSlice;

export { authenticationActions, authenticationReducers };
